import PathList from "../../Common/PathList";
import dash from "../../Assets/Sidebar/dash.svg";
import user from "../../Assets/Sidebar/User.svg";
import pay from "../../Assets/Sidebar/payment.svg";
import booking from "../../Assets/Sidebar/booking.svg";
import inquiry from "../../Assets/Sidebar/contact-form 1.svg";
import Ainquiry from "../../Assets/Sidebar/contact-form 2.svg";
import owner from "../../Assets/Sidebar/owner.svg";
import Adash from "../../Assets/Sidebar/Adash.svg";
import Auser from "../../Assets/Sidebar/AUser.svg";
import Apay from "../../Assets/Sidebar/Apayment.svg";
import Abooking from "../../Assets/Sidebar/Abooking.svg";
import AContact from "../../Assets/Sidebar/Ainquiry.svg";
import Contact from "../../Assets/Sidebar/inquiry.svg";
import Aowner from "../../Assets/Sidebar/Aowner.svg";
import Acontent from "../../Assets/Sidebar/Acontent.svg";
import content from "../../Assets/Sidebar/content.svg";
import faq from "../../Assets/Sidebar/faq.svg";
import AFaq from "../../Assets/Sidebar/Afaq.svg";
import Review from "../../Assets/Sidebar/Review.svg";
import AReview from "../../Assets/Sidebar/AReview.svg";
import ADisc from "../../Assets/Sidebar/ADisc.svg";
import Disc from "../../Assets/Sidebar/Disc.svg";

export const MenuList = [
  {
    id: 1,
    title: "Dashboard",
    url: PathList._Dashboard,
    icon: dash,
    Aicon: Adash,
  },
  {
    id: 2,
    title: "Users",
    url: PathList._User,
    icon: user,
    Aicon: Auser,
  },
  {
    id: 3,
    title: "Partners",
    url: PathList._Partners,
    icon: owner,
    Aicon: Aowner,
  },
  {
    id: 4,
    title: "Bookings",
    url: PathList._Booking,
    icon: booking,
    Aicon: Abooking,
  },
  {
    id: 5,
    title: "Content",
    url: PathList._Content,
    icon: content,
    Aicon: Acontent,
  },
  {
    id: 9,
    title: "Inquiry",
    url: PathList._Inquiry,
    icon: inquiry,
    Aicon: Ainquiry,
  },
  {
    id: 6,
    title: "Review",
    url: PathList._Review,
    icon: Review,
    Aicon: AReview,
  },
  {
    id: 10,
    title: "News Letter",
    url: PathList._NewsLetter,
    icon: pay,
    Aicon: Apay,
  },
  {
    id: 11,
    title: "Discount Coupon",
    url: PathList._Disc_Coupon,
    icon: Disc,
    Aicon: ADisc,
  },

  {
    id: 7,
    title: "Contact",
    url: PathList._Contact,
    icon: Contact,
    Aicon: AContact,
  },
  {
    id: 8,
    title: "FAQs",
    url: PathList._FAQs,
    icon: faq,
    Aicon: AFaq,
  },
];
